import { render } from "./ExpenditureStatisticsDetails.vue?vue&type=template&id=4c811f8d"
import script from "./ExpenditureStatisticsDetails.vue?vue&type=script&lang=js"
export * from "./ExpenditureStatisticsDetails.vue?vue&type=script&lang=js"

import "./ExpenditureStatisticsDetails.vue?vue&type=style&index=0&id=4c811f8d&lang=css"

import exportComponent from "/Users/admin/Desktop/bos-vue/node_modules/_vue-loader@17.0.0@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__